export enum DashboardNavSectionType {
  Favorite = 'FAVORITE',
  My = 'MY',
  Published = 'PUBLISHED',
  Shared = 'SHARED',
}
